/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Nur die Rollen, die der Baustein anzeigt — nicht der ganze Datensatz.
 * Was der Betreiber keiner Rolle zugewiesen hat, steht hier nicht drin
 * und geht damit auch nicht ueber die Leitung.
 * @export
 * @interface DatabaseSubDbListItem
 */
export interface DatabaseSubDbListItem {
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    entryId?: string;
    /**
     * Platzziffer, beginnend bei 1 — fuer Rangliste und Treppchen.
     * @type {number}
     * @memberof DatabaseSubDbListItem
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    badge?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    title?: string;
    /**
     * Der fertig gestaltete Inhalt dieses Datensatzes (HTML aus dem
     * Editor). Nur die Art `FREIE_GESTALTUNG` zeigt ihn.
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    gestaltung?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    price?: string;
    /**
     * Nur beim Baustein „Feld aus Datenbank": die Kennung des Feldes,
     * dessen Wert in `text` steht. Die Anzeige braucht sie zum
     * ZURUECKSCHREIBEN — welches Feld gilt, entscheidet der Server
     * (es kann ueber ein Zahlenfeld wechseln).
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    feldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    zielgruppe?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    button?: string;
    /**
     * Dateikennung des Bildes, wie sie der Bild-Endpunkt erwartet.
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    popup?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    link?: string;
    /**
     * Die Anordnung DIESES Eintrags — nur gesetzt, wenn der Baustein ein
     * `layoutFieldId` traegt. Sonst gilt die Anordnung des Bausteins.
     * 
     * WOFUER: sechs verschiedene Banner im Wechsel. Ohne diese Angabe
     * sahen alle Eintraege einer rotierenden Reihe gleich aus.
     * @type {string}
     * @memberof DatabaseSubDbListItem
     */
    layout?: string;
    /**
     * Wahr, wenn dieser Eintrag nur als Rueckfall einspringt.
     * @type {boolean}
     * @memberof DatabaseSubDbListItem
     */
    fallback?: boolean;
}

/**
 * Check if a given object implements the DatabaseSubDbListItem interface.
 */
export function instanceOfDatabaseSubDbListItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbListItemFromJSON(json: any): DatabaseSubDbListItem {
    return DatabaseSubDbListItemFromJSONTyped(json, false);
}

export function DatabaseSubDbListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryId': !exists(json, 'entryId') ? undefined : json['entryId'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'badge': !exists(json, 'badge') ? undefined : json['badge'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'gestaltung': !exists(json, 'gestaltung') ? undefined : json['gestaltung'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'feldId': !exists(json, 'feldId') ? undefined : json['feldId'],
        'zielgruppe': !exists(json, 'zielgruppe') ? undefined : json['zielgruppe'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'button': !exists(json, 'button') ? undefined : json['button'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'popup': !exists(json, 'popup') ? undefined : json['popup'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'layout': !exists(json, 'layout') ? undefined : json['layout'],
        'fallback': !exists(json, 'fallback') ? undefined : json['fallback'],
    };
}

export function DatabaseSubDbListItemToJSON(value?: DatabaseSubDbListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryId': value.entryId,
        'rank': value.rank,
        'badge': value.badge,
        'title': value.title,
        'gestaltung': value.gestaltung,
        'text': value.text,
        'price': value.price,
        'feldId': value.feldId,
        'zielgruppe': value.zielgruppe,
        'label': value.label,
        'icon': value.icon,
        'button': value.button,
        'image': value.image,
        'popup': value.popup,
        'link': value.link,
        'layout': value.layout,
        'fallback': value.fallback,
    };
}

